// import get from 'lodash.get'

/**
 * 魔方系统的接口标准响应码处理
 * config 选项
 * - doNotCheck 不做检查
 * @see http://rd.g.lenovo.com.cn/cube/apidoc/#api-_
 * @param service
 * @return {*}
 */
export default function cubeResponseCheckIntercept(service) {
  service.interceptors.response.use(response => {
    if (!response.config.doNotCheck && response.data.statusCode !== 200) {
      // const msg = get(response, 'data.message.info', '')
      // return Promise.reject(msg || 'Cube API Error: ' + response.config.url)
      return Promise.reject(response)
    }
    return response
  }, (error) => {
    return Promise.reject(error)
  })

  return service
}



// WEBPACK FOOTER //
// ./src/utils/axios-interceptor/cube-response-check.js